export default {
  'meta': {
    'langName': 'HONGARIAN',
    'lang': 'Magyar'
  },
  'title': 'TERMÉKVISSZAHÍVÁS\nBTWIN SD500E VAGY MD500E ELEKTROMOS ROLLER',
  'description': 'Kedves Vásárlónk!\n\nKöszönjük, hogy a BTWIN márka SD500E vagy MD500E elektromos rollerét választottad.\n\nMivel a biztonságod a legfontosabb számunkra, kérjük, figyelmesen olvasd el az alábbi tájékoztatást.\n\nA szigorú minőségellenőrzési folyamatok ellenére a BTWIN SD500E és MD500E elektromos rollereknél biztonsági kockázatot azonosítottunk. Az intenzív használat következtében repedés jelenhet meg a váz és a kormányszár csatlakozásánál. Ez a rész emiatt eltörhet, ami eséshez és sérüléshez vezethet.\n\nKérjük, válaszolj az alábbi kérdésekre, hogy biztosíthassuk a terméked biztonságos használatát vagy a megfelelő megoldást.\n\nA kellemetlenségért elnézésedet kérjük, és köszönjük a bizalmadat.\n\nDecathlon',
  'emailConfirmation': {
    'title': 'Először is, erősítsd meg az e-mail címedet és a lakóhelyed szerinti országot:'
  },
  'fields': {
    'country': 'Ország',
    'address': 'E-mail cím',
    'email': 'E-mail cím',
    'phonePrefix': 'Országhívószám',
    'phone': 'Telefonszám',
    'validations': {
      'phoneOrEmail': 'Kérjük, adj meg legalább egy e-mail címet VAGY telefonszámot.',
      'email': 'Kérjük, adj meg egy érvényes e-mail címet',
      'phone': 'Kérjük, adj meg egy érvényes telefonszámot',
      'selectAddress': 'Kérjük, válassz ki egy teljes címet a listából (házszám, utca és város).',
      'incompleteAddress': 'A címnek tartalmaznia kell a házszámot, az utcát és a várost. Írd be legalább a házszámot és az utcanevet, majd válassz a javaslatok közül.'
    },
    'firstName': 'Vezetéknév',
    'lastName': 'Keresztnév',
    'deliveryAddress': 'A csomag szállítási címe',
    'additionalAddress': 'További címadatok',
    'city': 'Település',
    'zip': 'Irányítószám',
    'readConfirmation': 'Az adatokat ellenőriztem, a tájékoztatást elolvastam és tudomásul vettem.',
    'choose': 'Válassz',
    'required': 'Kötelező mező',
    'deliveryAddressHelp': 'Írd be a házszámot és az utcanevet, majd válassz egy teljes címet a listából. ',
    'streetOnlyHint': 'Adj meg házszámot is.'
  },
  'ownerCheck': {
    'title': 'Birtokodban van még egy vagy több BTWIN SD500E, illetve MD500E elektromos roller?'
  },
  'yes': 'IGEN',
  'no': 'NEM',
  'ownerChanged': {
    'title': 'Megvan a kosárlabdapalánk jelenlegi tulajdonosának elérhetősége?',
    'confirmation': 'Kedves Vásárlónk!\n\nKöszönjük, hogy részt veszel ebben a minőségellenőrzésben.\n\nElnézésedet kérjük az esetleges kellemetlenségekért, és köszönjük a bizalmadat.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Kérjük, add meg, hány darab BTWIN márkájú SD500E vagy MD500E elektromos rolled van',
    'descriptionSd500': 'SD500E elektromos roller',
    'descriptionEmd500e': 'MD500E elektromos roller',
    'modelNumberHelp': 'A modell termékkódját (SD500E vagy MD500E) a roller alján találod, ahogy az itt látható ábrán is szerepel',
    'quantity': 'Mennyiség',
    'confirmation': 'Köszönjük, hogy kitöltötted az űrlapot, kérésedet sikeresen rögzítettük.\n\nLegfeljebb 20 napon belül értesítünk arról, mikortól válik lehetővé a javítás.\n\nSzép napot kívánunk!\n\nDecathlon'
  },
  'repair': {
    'title': 'Önálló javítás',
    'description': 'Arra kérünk, hogy ne használd tovább a terméket.\n\nA rollered biztonságossá tételéhez egy javítókészletet és egy útmutatót küldünk az otthoni címedre. A készlet teljesen ingyenes, használata pedig gyors és egyszerű.\n\nAz adataid rögzítése után legfeljebb 20 napon belül keresni fogunk, hogy egyeztessük, mikor lesz elérhető a javítókészlet. Mindent megteszünk azért, hogy a várakozási időt a lehető legrövidebbre csökkentsük.',
    'videoLink': 'Link a videóhoz',
    'store': 'Link az útmutatóhoz',
    'kitLabel': 'Teljes javítókészlet',
    'docLabel': 'Javítási útmutató',
    'callToAction': 'Kattints ide az ingyenes javítókészlet igényléséhez',
    'infoConfirmation': 'Ellenőrizd a részleteket',
    'validateConfirmation': 'Validál',
    'backConfirmation': 'Visszaküld'
  },
  'repairRequest': {
    'title': 'Kérjük, add meg az alábbi adatokat a javítókészlet igényléséhez:'
  },
  'form': {
    'submit': 'Következő'
  },
  'status': 'Translation validated by COUNTRY'
} as const
